import api from '@/api'
import request from '@/utils/request'
import router from '@/router/index.js'
import store from '@/store/index.js'
import { YJJ_ENV } from '../config'

/*
    参数：
    phone        
    type  1：订货会系统  2:万物入口   3=云仓商城    4=订货系统
*/
export function toDwSystem() {
    request({
        url: api.freeAccessLogin,
        data: {
            phone: store.state.user.phone,
            type: 3,
        },
        loading: true,
    }).then(res => {
        console.log(res)
        if (res.errorCode == 200) {
            // location.href = `http://10.10.1.126:8081/#/?yjj_phone=${res.data.phone}&yjj_code=${res.data.code}`
            if (YJJ_ENV == 'dev') {
                window.open(`https://dw.dev.fzzht.com/#/?yjj_phone=${res.data.phone}&yjj_code=${res.data.code}`, '_blank')
            }
            if (YJJ_ENV == 'test') {
                window.open(`https://dw.test.fzzht.com/#/?yjj_phone=${res.data.phone}&yjj_code=${res.data.code}`, '_blank')
            }
            if (YJJ_ENV == 'prod') {
                window.open(`https://dw.fzzht.com/#/?yjj_phone=${res.data.phone}&yjj_code=${res.data.code}`, '_blank')
            }
        } else {
            router.push('/enterDw')
        }
    })
}

export function toBrandOrderingSystem() {
    window.open('https://www.fzzht.com/products-ordering-system.html', '_blank')
    /*
        暂不跳转品牌商订货系统管理后台， 直接跳转订货系统介绍页
       
        request({
            url: api.freeAccessLogin,
            data: {
                phone: store.state.user.phone,
                type: 4,
            },
            loading: true,
        }).then(res => {
            console.log(res)
            if (res.errorCode == 200) {
                if (YJJ_ENV == 'dev') {
                    window.open(`https://admin.d.dev.fzzht.com/#/?yjj_phone=${res.data.phone}&yjj_code=${res.data.code}`, '_blank')
                }
                if (YJJ_ENV == 'test') {
                    window.open(`https://admin.d.test.fzzht.com/#/?yjj_phone=${res.data.phone}&yjj_code=${res.data.code}`, '_blank')
                }
                if (YJJ_ENV == 'prod') {
                    window.open(`https://admin.d.fzzht.com/#/?yjj_phone=${res.data.phone}&yjj_code=${res.data.code}`, '_blank')
                }
            } else {
                window.open('https://www.fzzht.com/products-ordering-system.html', '_blank')
            }
        })
    */
}